module.exports = __webpack_public_path__ + "img/p01.97f5bf66.png";